// Dictionary, 840 part 1 — the 840-specific beginning segment: BQT
// (Beginning Segment for Request for Quotation). Generic X12 840 (004010)
// definitions only; not tied to any trading partner's implementation guide.
//
// Everything else the 840 header body, its Name (N1) loop and its
// requested-line-item loop use — CUR, REF, PER, FOB, ITD, DTM, N1-N9 (in
// dictionary/header-segments.ts), PO1, PID, MEA, CTP, SAC, SDQ (in
// dictionary/item-loop-segments.ts) — is a segment X12 defines once and
// reuses across transaction sets, so it's already defined elsewhere and
// merged in by index.ts. This file does not redefine any of them.

import {LoopId, type ElementDefinition, type SegmentDefinition} from './types';
import {TRANSACTION_SET_PURPOSE_CODES} from './transaction-set-purpose-codes';

function el(
  position: number,
  label: string,
  description: string,
  extra: Partial<ElementDefinition> = {}
): ElementDefinition {
  return {position, label, description, ...extra};
}

export const SEGMENTS_840: Record<string, SegmentDefinition> = {
  BQT: {
    id: 'BQT',
    name: 'Beginning Segment for Request for Quotation',
    purpose:
      'Identifies the quote request number and what kind of request this is. Required at the start of every 840.',
    loop: LoopId.Header,
    required: true,
    elements: [
      el(
        1,
        'Transaction Set Purpose Code',
        'Whether this is an original request, a change, a replacement, etc.',
        {
          dataType: 'code',
          required: true,
          codes: TRANSACTION_SET_PURPOSE_CODES,
        }
      ),
      el(2, 'Reference Identification', 'The RFQ/quote request number.', {
        required: true,
      }),
      el(3, 'Date', 'Date the request for quotation was prepared.', {
        dataType: 'date',
        format: 'CCYYMMDD',
        required: true,
      }),
      el(
        4,
        'Request Reference Number',
        'A reference number this request is tied to, when applicable.'
      ),
      el(5, 'Contract Number', 'A related contract number, when applicable.'),
    ],
  },
};
